import { render, staticRenderFns } from "./SignInDialog.vue?vue&type=template&id=0c65cddb&scoped=true"
import script from "./SignInDialog.vue?vue&type=script&lang=ts"
export * from "./SignInDialog.vue?vue&type=script&lang=ts"
import style0 from "./SignInDialog.vue?vue&type=style&index=0&id=0c65cddb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c65cddb",
  null
  
)

export default component.exports